import { createSlice } from '@reduxjs/toolkit';
import { FETCH_PERMISSIONS } from '@sm/actions/types';

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    permissions: [],
    roleId: null,
    userId: null,
    userUpdate: null,
    wlOtcEnabled: false,
    fireblocksEnabled: false,
    topUpFeeEnabled: false
  },
  reducers: {
    setUserInfo(state, action) {
      const { permissions, roleId, wlOtcEnabled, userId, fireblocksEnabled, topUpFeeEnabled } = action.payload;
      state.permissions = permissions;
      state.roleId = roleId;
      state.wlOtcEnabled = wlOtcEnabled;
      state.fireblocksEnabled = fireblocksEnabled;
      state.topUpFeeEnabled = topUpFeeEnabled;
      state.userId = userId;
      state.userUpdate = FETCH_PERMISSIONS;
    }
  }
});

export const { setUserInfo } = authSlice.actions;
export default authSlice.reducer;